export default {
}



// WEBPACK FOOTER //
// ./~/vue-components/live-coach/store/getters.js